import { useState, useRef } from "react";
import resume from "./Balogun_sodiq.pdf";
import mylogo2 from "./mylogo2.png";
import sunLogo from "./components/images/sun2.png";
import moonLogo from "./components/images/moonLogo.png";
import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineClose } from "react-icons/ai";
import Testimonials from "./components/testimonials";
import Certifications from "./components/certifications";
import About from "./components/about";
import Skills from "./components/skills";
import Contact from "./components/contact";
import LazyLoadComponent from "./components/lazyCompnent";

import {
  HStack,
  VStack,
  Box,
  Link,
  Spacer,
  Flex,
  Button,
  Image,
  Text,
  useColorMode,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";
import Project from "./components/project";
function App() {
  const aboutRef = useRef(null);
  const skillRef = useRef(null);
  const projectRef = useRef(null);
  const honorRef = useRef(null);
  const CertificateRef = useRef(null);
  const ContactRef = useRef(null);
  const { colorMode, toggleColorMode } = useColorMode();

  const handleAboutClick = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  const handleSkillClick = () => {
    skillRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  const handleProjectClick = () => {
    projectRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  const handleHonorClick = () => {
    honorRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  const handleCertficateClick = () => {
    CertificateRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  const handleContactClick = () => {
    ContactRef.current?.scrollIntoView({ behavior: "smooth" });
    changeDisplay(false);
  };
  let [display, changeDisplay] = useState(false);

  const bodybg = useColorModeValue("gray.200", "gray.800");
  const headerbg = useColorModeValue("gray.200", "teal.800");
  const headertxt = useColorModeValue("black", "white");
  const dividerbg = useColorModeValue("teal.500", "teal.700");
  const btnhover = useColorModeValue("white", "teal.900");

  return (
    <Box minH="100vh" bg={bodybg}>
      {/* Header */}
      <Box>
        <HStack
          p={{ base: "20px", lg: "20px" }}
          justifyContent="center"
          spacing={{ base: "0px", lg: "100px", xl: "230px" }}
          bg={headerbg}
          opacity="90%"
          display={{ base: "none", lg: "flex" }}
          position="fixed"
          top={0}
          zIndex={99999}
          width="100%"
        >
          <Box>
            <Image w="50px" h="50px" src={mylogo2} cursor="pointer" />
          </Box>
          <HStack spacing="50px">
            <Box>
              <Text
                onClick={handleAboutClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                About
              </Text>
            </Box>
            <Box>
              <Text
                onClick={handleSkillClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                Skills
              </Text>
            </Box>
            <Box>
              <Text
                onClick={handleProjectClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                Projects
              </Text>
            </Box>
            <Box>
              <Text
                onClick={handleHonorClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                Testimonials
              </Text>
            </Box>
            <Box>
              <Text
                onClick={handleCertficateClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                Certifications
              </Text>
            </Box>
            <Box>
              <Text
                onClick={handleContactClick}
                cursor="pointer"
                color={headertxt}
                _hover={{ color: "teal.500" }}
              >
                Contact
              </Text>
            </Box>
          </HStack>

          <HStack>
            <Box onClick={toggleColorMode} cursor="pointer">
              {colorMode === "light" ? (
                <img width={20} height={20} src={moonLogo} alt="logo" />
              ) : (
                <img width={20} height={20} src={sunLogo} alt="logo" />
              )}
            </Box>
            <Link href={resume} target="_blank">
              <Button bg="teal.500" _hover={{ color: btnhover }}>
                Resume
              </Button>
            </Link>
          </HStack>
        </HStack>

        {/* Hamburger */}
        <Box
          display={{ base: "block", lg: "none" }}
          bg={headerbg}
          opacity="90%"
          position="fixed"
          top={0}
          zIndex={99999}
          width="100%"
        >
          <Flex p="20px" display={display ? "none" : "flex"}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Image w="35px" h="35px" src={mylogo2} alt="logo" />
            </Box>
            <Spacer />
            <Box>
              <HStack
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box onClick={toggleColorMode} cursor="pointer">
                  {colorMode === "light" ? (
                    <img width="25px" height="25px" src={moonLogo} alt="logo" />
                  ) : (
                    <img width="25px" height="25px" src={sunLogo} alt="logo" />
                  )}
                </Box>
                <RxHamburgerMenu
                  onClick={() => changeDisplay(true)}
                  size="25px"
                  color="#8A8A8A"
                  style={{ cursor: "pointer", width: "35px", height: "35px" }}
                />
              </HStack>
            </Box>
          </Flex>
        </Box>

        <Box
          mt="0"
          mb="0"
          bg="teal.800"
          display={{ base: "block", lg: "none" }}
          position="fixed"
          w="100%"
          mr="auto"
          ml="auto"
          zIndex={999}
        >
          <Box display={display ? "block" : "none"}>
            <Box p="4" align="right">
              <AiOutlineClose
                onClick={() => changeDisplay(false)}
                size="25px"
                color="#FFFFFF"
                style={{ cursor: "pointer" }}
              />
            </Box>

            <VStack spacing="30px">
              <Box>
                <Text
                  onClick={handleAboutClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  About
                </Text>
              </Box>
              <Box>
                <Text
                  onClick={handleSkillClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  Skills
                </Text>
              </Box>
              <Box>
                <Text
                  onClick={handleProjectClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  Projects
                </Text>
              </Box>
              <Box>
                <Text
                  onClick={handleHonorClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  Testimonials
                </Text>
              </Box>
              <Box>
                <Text
                  onClick={handleCertficateClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  Certifications
                </Text>
              </Box>
              <Box>
                <Text
                  onClick={handleContactClick}
                  cursor="pointer"
                  color="white"
                  _hover={{ color: "teal.500" }}
                >
                  Contact
                </Text>
              </Box>
              <Box pb="30px">
                <Link href={resume} target="_blank">
                  <Button bg="teal.500" _hover={{ color: btnhover }}>
                    Resume
                  </Button>
                </Link>
              </Box>
            </VStack>
          </Box>
        </Box>
      </Box>

      <Box bg={bodybg}>
        {/* About */}

        <LazyLoadComponent forwardedRef={aboutRef}>
          <About />
        </LazyLoadComponent>
        <Divider borderColor={dividerbg} />
        {/* Skills */}
        <LazyLoadComponent forwardedRef={skillRef}>
          <Skills />
        </LazyLoadComponent>
        <Divider borderColor={dividerbg} />
        {/* Project */}
        <LazyLoadComponent forwardedRef={projectRef}>
          <Project />
        </LazyLoadComponent>
        <Divider borderColor={dividerbg} />
        {/* Testimonials */}
        <LazyLoadComponent forwardedRef={honorRef}>
          <Testimonials />
        </LazyLoadComponent>
        <Divider />
        {/* Certification */}
        <LazyLoadComponent forwardedRef={CertificateRef}>
          <Certifications />
        </LazyLoadComponent>
        <Divider borderColor={dividerbg} />
        {/* Contact */}

        <LazyLoadComponent forwardedRef={ContactRef}>
          <Contact handleAboutClick={handleAboutClick} dataSection="contact" />
        </LazyLoadComponent>
      </Box>
    </Box>
  );
}

export default App;

// "chakra-ui-carousel": "^1.0.7",
